/** Telefon fotoğraflarını tarayıcıda düzleştirip JPEG olarak döndürür (EXIF yönü). */
export async function normalizeImageFile(file) {
    if (!file?.type?.startsWith("image/")) return file;
    try {
        const bitmap = await createImageBitmap(file);
        const canvas = document.createElement("canvas");
        canvas.width = bitmap.width;
        canvas.height = bitmap.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(bitmap, 0, 0);
        bitmap.close?.();
        const blob = await new Promise((resolve, reject) => {
            canvas.toBlob(
                (b) => (b ? resolve(b) : reject(new Error("blob oluşturulamadı"))),
                "image/jpeg",
                0.92,
            );
        });
        const base = (file.name || "evrak").replace(/\.[^.]+$/, "");
        return new File([blob], `${base}.jpg`, {
            type: "image/jpeg",
            lastModified: Date.now(),
        });
    } catch {
        return file;
    }
}

/** Seçili görseli saat yönünde döndürür (90° adımlar). */
export async function rotateImageFile(file, degrees = 90) {
    if (!file?.type?.startsWith("image/")) return file;
    const bitmap = await createImageBitmap(file);
    const rad = (degrees * Math.PI) / 180;
    const sin = Math.abs(Math.sin(rad));
    const cos = Math.abs(Math.cos(rad));
    const w = Math.round(bitmap.width * cos + bitmap.height * sin);
    const h = Math.round(bitmap.width * sin + bitmap.height * cos);
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    ctx.translate(w / 2, h / 2);
    ctx.rotate(rad);
    ctx.drawImage(bitmap, -bitmap.width / 2, -bitmap.height / 2);
    bitmap.close?.();
    const blob = await new Promise((resolve, reject) => {
        canvas.toBlob(
            (b) => (b ? resolve(b) : reject(new Error("blob oluşturulamadı"))),
            "image/jpeg",
            0.92,
        );
    });
    const base = (file.name || "evrak").replace(/\.[^.]+$/, "");
    return new File([blob], `${base}.jpg`, {
        type: "image/jpeg",
        lastModified: Date.now(),
    });
}
